import React from "react";
import "./styles.less";

export const Link = (props) => {
  const { children, ...restProps } = props;
  return (
    <a className="authing-link-cus" {...restProps}>
      {children}
    </a>
  );
};
